import styled from '@emotion/styled';

import {
  animation,
  breakpoints,
  colors,
  fontSize,
  fontWeight,
} from '@datacamp/waffles-tokens';

export const Container = styled.section`
  align-items: center;
  display: flex;
  border-bottom: 1px solid ${colors.greyLight};
  margin: 32px 16px 24px;

  @media screen and (min-width: ${breakpoints.xs}) {
    margin: 32px 16px;
  }

  @media screen and (min-width: ${breakpoints.lg}) {
    margin: 40px 0 16px;
  }
`;

export const Fieldset = styled.fieldset`
  border: 0;
  margin: 0;
  padding: 0 12px;

  &:first-of-type {
    padding-left: 0;
  }
`;

export const Label = styled.label`
  color: ${colors.greyDark};
  cursor: pointer;
  display: block;
  font-size: ${fontSize.small};
  justify-content: space-between;
  padding: 12px 0;
  position: relative;
  text-transform: uppercase;

  &::after {
    background-color: ${colors.primary};
    border-radius: 3px; /* DS violation to make a pill */
    bottom: -2px;
    box-shadow: 0 3px 8px 0 ${colors.primaryLight};
    content: '';
    display: block;
    left: 0;
    height: 3px;
    opacity: 0;
    position: absolute;
    right: 0;
    transition: opacity ${animation.transition};
  }
`;

export const Radio = styled.input`
  display: none;

  &:checked + label {
    color: ${colors.primary};
    display: flex;
    font-weight: ${fontWeight.bold};
    position: relative;

    &::after {
      opacity: 1;
    }
  }
`;
